export default "__VITE_ASSET__CG2VbvfG__"